import { Typography } from '@material-ui/core';
import React from 'react';
import { CopyVersionDropdown } from './CopyVersionDropdown';
import PropTypes from 'prop-types';

export const CopyVersionDropdownGroup = ({
  groupStyle,
  dropdownStyle,
  dropdownGroupHeader,
  tc,
  periodLabelId,
  yearLabelId,
  periodOnChange,
  yearOnChange,
  periodValue,
  yearValue,
  periodOptions,
  yearOptions,
  dateRange,
  disabled,
}) => {
  return (
    <div className="CVSelectTableWrapper">
      <div className="CVSelectTableHeader">
        <Typography variant="h6" className="CVSelectTableHeaderText">
          {dropdownGroupHeader}
        </Typography>
      </div>
      <div className="CVSelectTableDropdownWrapper">
        <div className="CVSelectTableDropdownRowWrapper" style={groupStyle}>
          <CopyVersionDropdown
            className="CVSelectTableDropdownPeriodWrapper"
            style={dropdownStyle}
            inputLabel={tc('PERIOD')}
            labelId={periodLabelId}
            dropdownVariant={'outlined'}
            dropdownValue={periodValue}
            onChange={periodOnChange}
            options={periodOptions}
          />
          <CopyVersionDropdown
            className="CVSelectTableDropdownYearWrapper"
            inputLabel={tc('YEAR')}
            labelId={yearLabelId}
            dropdownVariant={'outlined'}
            dropdownValue={yearValue}
            onChange={yearOnChange}
            options={yearOptions}
            disabled={disabled}
          />
        </div>
        <div className="CVSelectTableDateRange">
          <i>{`${tc('DATE_RANGE')}: ${dateRange}`}</i>
        </div>
      </div>
    </div>
  );
};

CopyVersionDropdownGroup.propTypes = {
  groupStyle: PropTypes.object,
  dropdownStyle: PropTypes.object,
  dropdownGroupHeader: PropTypes.string,
  tc: PropTypes.func,
  periodLabelId: PropTypes.string,
  yearLabelId: PropTypes.string,
  periodOnChange: PropTypes.func,
  yearOnChange: PropTypes.func,
  periodValue: PropTypes.string,
  yearValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  periodOptions: PropTypes.array,
  yearOptions: PropTypes.array,
  dateRange: PropTypes.string,
  disabled: PropTypes.bool,
};